import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { routes } from './app-routes';

const router = createRouter({
  history: process.env.NODE_ENV === 'webcomponent'
  ? createWebHashHistory(process.env.BASE_URL || '/')
  : createWebHistory(process.env.BASE_URL || '/'),
	routes,
});

export default router;
